export default __webpack_public_path__ + "static/media/ammeter.83b6c0ed.svg";